"use strict";

var _classCallCheck = require("D:/endimension/radsmart_website/Superprops/Superprops/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("D:/endimension/radsmart_website/Superprops/Superprops/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("D:/endimension/radsmart_website/Superprops/Superprops/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("D:/endimension/radsmart_website/Superprops/Superprops/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("D:/endimension/radsmart_website/Superprops/Superprops/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Circle = void 0;

var Range_1 = require("./Range");

var NumberUtils_1 = require("./NumberUtils");

var Circle = /*#__PURE__*/function (_Range_1$Range) {
  _inherits(Circle, _Range_1$Range);

  var _super = _createSuper(Circle);

  function Circle(x, y, radius) {
    var _this;

    _classCallCheck(this, Circle);

    _this = _super.call(this, x, y);
    _this.radius = radius;
    return _this;
  }

  _createClass(Circle, [{
    key: "contains",
    value: function contains(point) {
      return (0, NumberUtils_1.getDistance)(point, this.position) <= this.radius;
    }
  }, {
    key: "intersects",
    value: function intersects(range) {
      var rect = range;
      var circle = range;
      var pos1 = this.position;
      var pos2 = range.position;
      var xDist = Math.abs(pos2.x - pos1.x);
      var yDist = Math.abs(pos2.y - pos1.y);
      var r = this.radius;

      if (circle.radius !== undefined) {
        var rSum = r + circle.radius;
        var dist = Math.sqrt(xDist * xDist + yDist + yDist);
        return rSum > dist;
      } else if (rect.size !== undefined) {
        var w = rect.size.width;
        var h = rect.size.height;
        var edges = Math.pow(xDist - w, 2) + Math.pow(yDist - h, 2);

        if (xDist > r + w || yDist > r + h) {
          return false;
        }

        if (xDist <= w || yDist <= h) {
          return true;
        }

        return edges <= r * r;
      }

      return false;
    }
  }]);

  return Circle;
}(Range_1.Range);

exports.Circle = Circle;